<template>
  <div class="siteAccount">
    <!-- <div class="loginAccount athleteAccount">
      <b-link class="home_login" to="security/login?isSport=1">
        <img :src="require('../images/form/sport_logo.png')" alt="" />
        <h2>
          
          {{ $lang("TITLE_SPORT_MEMBER") }}
        </h2>
        <div>
          <span>{{ $lang("TEXT_LOGIN") }}</span>
          <img :src="require('../images/form/icon_01.png')" alt="" />
        </div>
      </b-link>
      <p>
        {{ $lang("TEXT_SPORT_LOGIN_TIP") }}
      </p>
    </div> -->
    <div class="loginAccount otherAccount">
      <b-link class="home_login2" to="security/login">
        <h2>
          {{ $lang("TITLE_OTHER_USER") }}
        </h2>
        <div>
          <span>{{ $lang("TEXT_LOGIN") }}</span>
          <img :src="require('../images/form/icon_02.png')" alt="" />
        </div>
      </b-link>
    </div>
    <div class="loginAccount noAccount">
      <b-link to="security/register">
        <h2 v-html="$lang('TITLE_IF_NOT_HAVE_ACCOUNT')"></h2>
        <div>
          <span>{{ $lang("TEXT_PLEASE_REG_NOW") }}</span>
          <img :src="require('../images/form/icon_03.png')" alt="" />
        </div>
      </b-link>
    </div>
    <b-modal v-model="isFull" hide-footer hide-header>
      <h3 class="text-center">{{ $lang("TITLE_IS_FULL") }}</h3>
      <b-button class="mt-3" block @click="isFull = false">{{
        $lang("TITLE_RETURN_INDEX")
      }}</b-button>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isFull: false,
    };
  },
  mounted() {
    this.fetchInit();
  },
  methods: {
    fetchInit() {
      this.$apis.init().then((res) => {
        if (res.code == 0) {
          this.isFull = res.data.SummerCarnival2019.isFull;
        } else {
        }
      });
    },
  },
};
</script>